module.exports = __webpack_public_path__ + "0204cfe3fcaf2e299b34be1d733bd1db.png";